import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import useMeta from 'quasar/src/composables/use-meta/use-meta.js';
export default /*@__PURE__*/Object.assign({
  name: 'App'
}, {
  __name: 'App',
  setup(__props) {
    useMeta({
      title: 'Home',
      titleTemplate: title => `${title} | Nave Contratos`
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view);
    };
  }
});